
<template>
  <Layer :visible="visible">
    <div
      class="dlrLayer-mask bgZero"
      @touchstart="toast"
      @touchmove="toast"
      @click="toast"
      @mousemove="toast"
    ></div>
  </Layer>
</template>
<script>
import Layer from '../Layer.vue';
import layerManager from '../../services/layer.manager';
export default {
  components: {
    Layer
  },
  props:{
    tips:{
      type:String,
      default:'客户正在操作！稍后再试'
    },
  },
  data: function () {
    return {
      visible: true
    };
  },
  activated () {
    this.visible = true;
  },
  deactivated () {
    this.visible = false;
  },
  methods: {
    toast (event) {
      event.preventDefault();
      if(this.tips) {
        layerManager.toast({ message: this.tips }, 1000);
      }
    }
  }
};
</script>
<style lang="scss">
.bgZero {
  opacity: 0;
}
</style>
